<template>
  <div class="buy-member-slots">
    <div class="buy-member-slots__title">
      <span> {{ $t('xuan-ze-xi-wei-shu-liang') }} </span>
      <span class="period">
        {{ $t('gou-mai-hou-you-xiao-qi-zhi-expireformat-0', [expireFormat]) }}
      </span>
    </div>
    <div class="buy-member-slots__sub">
      {{ $t('jia-gou-xi-wei-gou-mai-cheng-gong-hou-li-ji-sheng-xiao') }}
    </div>
    <div class="buy-member-slots__block">
      <div class="title">{{ $t('xi-wei') }}</div>
      <div class="display_price">
        <span class="red">
          <span class="prefix">{{ displayPrice.prefix }}</span>
          <span class="value">{{ displayPrice.value }}</span>
        </span>
        / {{ $t('nian') }}
      </div>
      <div class="original_price">
        {{ displayOriginalPrice }}
      </div>
      <div class="member-slots_count">
        {{ $t('gou-mai-shu-liang') }}
        <a-input-number
          v-model:value="state.num"
          class="input"
          :precision="0"
          :step="1"
          :min="1"
          :max="10000"
          @blur="handleInputChange"
        />
        {{ $t('xi-wei') }}
      </div>
    </div>
    <div class="buy-member-slots__summary">
      <div class="summary_title">{{ $t('he-ji') }}</div>
      <div class="summary_price red">
        <span>{{ displayTotal.prefix }}</span>
        <span>
          {{ displayTotal.value }}
        </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts" name="seat-info">
import { useRightDetail } from '~/hooks/useRight'
import { useTime } from '~/hooks/useTime'

const detail = await useRightDetail()

const price = computed(() => {
  return detail.value!.add_price.add_account
})

const displayPrice = computed(() => formatPrice(price.value))

const displayOriginalPrice = computed(
  () => detail.value?.add_price.add_account_original
)

const props = defineProps<{ num: number }>()

const emit = defineEmits(['update:num'])

const state = reactive<{ num: number }>({ num: props.num })

const displayTotal = computed(() => formatPrice(state.num * price.value))

const { $dayjs } = useTime()

const expireFormat = computed(() =>
  $dayjs().add(1, 'year').format('YYYY/MM/DD')
)

const handleInputChange = () => {
  if (state.num === null) {
    state.num = 1
  }
  emit('update:num', state.num)
}
</script>

<style lang="scss" scoped>
.buy-member-slots {
  .red {
    color: var(--error-6);
  }
  &__title {
    color: var(--text-0);
    font-size: 16px;
    .period {
      color: var(--text-1-60);
      font-size: 12px;
      margin-left: 6px;
    }
  }
  &__sub {
    font-weight: 400;
    font-size: 14px;
    color: var(--text-1-60);
    line-height: 24px;
    text-align: left;
    font-style: normal;
    margin-bottom: 30px;
  }
  &__block {
    background-color: var(--back-4);
    border-radius: 12px;
    padding: 20px;
    .title {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .display_price {
      .prefix {
        font-size: 16px;
      }
      .value {
        font-size: 22px;
      }
    }
    .member-slots_count {
      display: flex;
      align-items: center;
      .input {
        width: 100px;
        margin: 0 10px 0 20px;
      }
    }
  }
  &__summary {
    margin-top: 30px;
    background-color: var(--back-3);
    border-radius: 12px;
    display: flex;
    padding: 21px 24px;
    align-items: center;
    justify-content: space-between;
    .summary_title {
      font-size: 16px;
    }
    .summary_price {
      font-size: 22px;
      span:first-child {
        font-size: 16px;
      }
    }
  }
}
</style>
